<template>
  <b-container class="col-md-12 mx-auto">
    <div>
      <div class="mt-4 d-flex justify-content-between">
        <back-arrow :confirm="askConfirm" :params="{operationId: operationId}"
                    :title="$t('Add') + ' ' + $t('a') + ' ' + $t('operationDocument')"
                    route-back="OperationShowDocuments"/>
      </div>
      <div class="row">
        <div class="col-md-12">
          <b-card class="mt-2 mb-4 shadow-sm">
            <b-form v-unsave-detector @submit.stop.prevent="onSubmit">
              <div v-for="(document, index) in documents" :key="index">
                <div class="d-flex mb-2">
                  <div class="section-title">
                    {{ $t("Document") }} {{ index + 1 }}
                  </div>
                  <div class="ml-2" v-if="documents.length > 1" @click="clickOnDeleteBtnDocument(document, index)">
                    <trash-icon color="#9E0430" size="18"/>
                  </div>
                </div>
                <div class="row align-items-center">
                  <div class="col-md-6">
                    <b-form-group
                      :key="document.key"
                      :invalid-feedback="document.file.invalidFeedback"
                      :label="$t('OperationDocument')"
                      :label-for="`document[${index}][file]-index`"
                      :state="document.file.state"
                      class="medium-label mb-4">
                      <custom-form-file
                        :id="`document[${index}][file]-index`"
                        :key="document.key"
                        v-model="document.file.value"
                        :browse-text="$t('Select')"
                        :disabled="document.date.value !== null && new Date(document.date.value) <= minDate"
                        :placeholder="document.file.value && document.file.value.name ? document.file.value.name : $t('Select') + ' ' + $t('a') + ' ' + $t('contactDocument.file')"
                        :required="document.id == null"
                        :state="document.file.state"
                        @change="removeInvalidFeedback(document,'file');askConfirm=true;"
                        @input="setName(document)"
                      />
                    </b-form-group>
                  </div>

                  <div class="col-md-6">
                    <b-form-group
                      :label="$t('OperationDocument.name')"
                      :label-for="`document[${index}][name]-index`"
                      class="medium-label mb-4">
                      <b-form-input
                        :id="`document[${index}][name]-index`"
                        v-model="document.name.value"
                        :disabled="document.date.value !== null && new Date(document.date.value) <= minDate"
                        maxlength="250"
                        required
                        type="text"
                        v-on:change="askConfirm=true;">
                      </b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-md-4">
                    <b-form-group
                      :label="$t('Dossier')"
                      class="medium-label mb-4"
                      label-for="dossier-input">
                      <b-form-select
                        id="dossier-input"
                        v-model="document.selectedFolderId.value"
                        v-on:change="askConfirm=true;">
                        <option v-for="folder in folderList" :value="folder.id">
                          {{ $t(folder.name) }}
                        </option>
                      </b-form-select>
                    </b-form-group>
                  </div>
                  <div class="col-md-4">
                    <b-form-group
                      :label="$t('OperationDocument.deadlineDate')"
                      :label-for="`document[${index}][date]-index`"
                      class="medium-label mb-4">
                      <datepicker-input
                        :id="`document[${index}][date]-index`"
                        v-model="document.date.value"
                        :disabled="document.date.value !== null && new Date(document.date.value) <= minDate"
                        :min="minDate"
                        v-on:change="askConfirm=true;"/>
                    </b-form-group>
                  </div>
                  <div class="col-md-4">
                    <b-form-group
                      :label="$t('Choix des lots')"
                      class="medium-label mb-4"
                      label-for="avpexe-input">
                      <b-form-select
                        id="avpexe-input"
                        v-model="document.avpexevalue">

                        <option value="general">Général à tous les lots</option>
                        <option value="avp">AVP</option>
                        <option value="exe">EXE</option>
                        <option value="avpexe">AVP/EXE</option>
                      </b-form-select>
                    </b-form-group>
                  </div>

                  <div class="col-md-12">
                    <b-form-group
                      v-if="document.avpexevalue !== 'general'"
                      :label="$t('operationConstructions.lots.tolink')"
                      :label-for="'lots-input'"
                      class="medium-label mb-2">

                      <div :id="'lots-input'" class="custom-container">
                        <template v-for="operationLot in operationLotsAVPEXE">
                          <b-form-checkbox
                            v-if="document.avpexevalue === 'avpexe'"
                            class="ml-2"
                            :ref="'checkbox' + operationLot.id + document.key"
                            :checked="document.selectedLots && document.selectedLots.includes(operationLot.id)"
                            @change="handleCheckboxChange(document, operationLot.id)">
                            <span v-if="operationLot.lotCoPro">
                              {{ $t('operation.bilan.Lot') + ' ' + operationLot.lotCoPro }}
                            </span>
                            <span v-else>{{ $t('operation.bilan.Lot') + ' ' + operationLot.lotNumber }}</span>
                            - AVP/EXE
                          </b-form-checkbox>
                        </template>
                        <template v-for="operationLot in operationLots">
                          <b-form-checkbox
                            v-if="operationLot.bilanType === document.avpexevalue.toUpperCase()"
                            class="ml-2"
                            :ref="'checkbox' + operationLot.id + document.key"
                            :checked="document.selectedLots && document.selectedLots.includes(operationLot.id)"
                            @change="handleCheckboxChange(document, operationLot.id)">
                            <span v-if="operationLot.lotCoPro">
                              {{ $t('operation.bilan.Lot') + ' ' + operationLot.lotCoPro }}
                            </span>
                            <span v-else>{{ $t('operation.bilan.Lot') + ' ' + operationLot.lotNumber }}</span>
                            -{{ operationLot.bilanType }}
                          </b-form-checkbox>
                        </template>
                      </div>
                    </b-form-group>
                  </div>
                </div>
              </div>

              <b-button class="btn-medium main-blue-color" variant="outline" @click="addDocument()">
                <plus-icon class="mr-1" size="16"/>
                {{ $t('Add') }} {{ $t('contactDocument') }}
              </b-button>

              <div class="d-flex justify-content-end">
                <b-button type="submit" variant="primary">{{ $t('Create') }}</b-button>
              </div>

            </b-form>
          </b-card>
        </div>
      </div>
    </div>
  </b-container>
</template>

<script>
import backArrow from "../../components/b122/BackArrow";
import api from "../../services/api";
import DatepickerInput from "../../components/b122/editFields/DatepickerInput.vue";
import CustomFormFile from "../../components/b122/editFields/CustomFormFile.vue";

export default {
  name: "OperationDocumentCreate",

  components: {
    backArrow,
    DatepickerInput,
    CustomFormFile
  },

  data() {
    return {
      operationId: this.$route.params.operationId,
      documents: [],
      operationLots: [],
      operationLotsAVPEXE: [],
      folderList: [],
      operationDocumentsIdsToRemove: [],
      minDate: null,
      askConfirm: false,
    }
  },

  mounted() {
    this.setDate()
    this.addDocument()
    console.log(this.$route.params)
    this.operationId = this.$route.params.operationId
    if (this.operationId) {
      this.getOperationLots()
      this.getFolders()
    } else {
      this.$router.go(-1)
    }


  },


  methods: {

    removeInvalidFeedback(doc, field) {
      doc[field]["state"] = null
    },

    setName(document) {
      document.name.value = document.file.value.name
    },

    setDate() {
      const now = new Date()
      this.minDate = new Date(now.getFullYear(), now.getMonth(), now.getDate())
    },

    addDocument() {
      this.documents.push({
        id: null,
        name:
          {
            state: null,
            invalidFeedback: null,
            value: ''
          },
        date:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        file:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        selectedFolderId:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        general: true,
        avpexevalue: "general",
        selectedLots: this.operationLots.map(lot => lot.id),

        key: Date.now()
      })
    },


    clickOnDeleteBtnDocument(document, index) {
      if (document.id) {
        this.operationDocumentsIdsToRemove.push(document.id)
      }
      this.documents.splice(index, 1)
    },


    async onSubmit() {
      try {
        const updateSuccess = await this.createOrUpdateOperationDocuments()
        const deleteSuccess = await this.deleteOperationDocuments()

        if (updateSuccess && deleteSuccess) {
          this.$router.push({
            name: 'OperationShowDocuments',
            params: {
              operationId: this.operationId,
              currentSection: 2
            }
          }, () => {
            this.$nextTick(() => {
              this.successToast()
            })
          })
        }
      } catch (error) {
      }
    },

    async createOrUpdateOperationDocuments() {
      const successfullyUploaded = []
      const failedDocuments = []

      for (const doc of this.documents) {
        try {
          let data = new FormData()
          data.append('document', doc.file.value)
          data.append('documentDate', doc.date.value)
          data.append('documentName', doc.name.value)
          data.append('operationId', this.operationId)
          data.append('selectedFolderId', doc.selectedFolderId.value)
          data.append('selectedLots', JSON.stringify(doc.selectedLots))
          data.append('avpExeValue', doc.avpexevalue)

          let url = '/operationDocument'
          if (doc.id) {
            url = '/operationDocument/' + doc.id
          }

          await api({
            method: 'POST',
            url: url,
            data: data
          })

          successfullyUploaded.push(doc)
        } catch (error) {
          if (error.response && error.response.status === 403) {
            const invalidField = error.response.data.invalidField
            doc[invalidField]['state'] = false
            doc[invalidField]['invalidFeedback'] = this.$i18n.t(error.response.data.message)
          } else if (error.response && (error.response.status === 401 || error.response.status === 404)) {
            this.$router.push({
              name: 'OperationDocumentCreate',
              params: {
                operationId: this.operationId
              }
            })
          }
          failedDocuments.push(doc)
        }
      }

      this.documents = this.documents.filter(doc => !successfullyUploaded.includes(doc))

      failedDocuments.forEach(doc => {
        doc.key = Date.now()
      })

      return failedDocuments.length === 0
    },


    async deleteOperationDocuments() {
      try {
        const successfullyDeleted = []

        for (const operationDocumentId of this.operationDocumentsIdsToRemove) {
          await api.delete(`/operationLot/${operationDocumentId}`)
          successfullyDeleted.push(operationDocumentId)
        }

        this.operationDocumentsIdsToRemove = this.operationDocumentsIdsToRemove.filter(
          id => !successfullyDeleted.includes(id)
        )

        return true
      } catch (error) {
        return false
      }
    },


    successToast() {
      this.$bvToast.toast(this.$i18n.t('Documents') + ' ' + this.$i18n.t('registered.object.s'), {
        autoHideDelay: 4000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: "success",
        solid: true,
      })
    },

    async getOperationLots() {
      await api
        .get(`/operationDocument/getAllForOperation/${this.operationId}`)
        .then(response => {
          this.operationLots = response.data
          console.log("this.operationLots.length")
          console.log(this.operationLots.length)

          this.operationLotsAVPEXE = []
          for (const lot of this.operationLots) {
            if (!this.operationLotsAVPEXE.some(l => l.lotNumber === lot.lotNumber)) {
              this.operationLotsAVPEXE.push(lot)
            }
          }
          for (const doc of this.documents) {
            doc.selectedLots = this.operationLots.map(lot => lot.id)
          }
        })
    },

    getFolders() {
      api.get('/operationDocument/getOperationFoldersWithoutDevisAndFactures/' + this.operationId).then(response => {
        this.folderList = response.data
      });
    },

    handleCheckboxChange(doc, lotId) {
      const index = doc.selectedLots.indexOf(lotId);
      if (index === -1) {
        doc.selectedLots.push(lotId);
      } else {
        if (doc.selectedLots.length > 1) {
          doc.selectedLots.splice(index, 1);
        } else {
          this.$refs["checkbox" + lotId + doc.key][0].checked = true;
          this.$refs["checkbox" + lotId + doc.key][0].computedLocalChecked = true;
          this.$refs["checkbox" + lotId + doc.key][0].localChecked = true;
        }
      }
    },
  }
}
</script>

<style scoped>

.custom-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
</style>



// WEBPACK FOOTER //
// src/views/operationDocument/OperationDocumentCreate.vue